import { render } from "./PageNotAvailable.vue?vue&type=template&id=02ba5c3f"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__